import selectableShiftsGroupUrl from './selectable-shifts-group.html';

class SelectableShiftsGroupCtrl {
  onShiftSelect(selectedShift) {
    this.selectedShift = selectedShift;
    this.onSelect({ selectedShift });
  }

  isUnavailable(shift) {
    return shift.exchangeData.isSwap;
  }
}

export default {
  controller: SelectableShiftsGroupCtrl,
  controllerAs: 'ctrl',
  bindings: {
    shiftsGroup: '<',
    onSelect: '&',
  },
  templateUrl: selectableShiftsGroupUrl,
};
